import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useParent } from '../../context/ParentContext';
import { useMobileContext } from '../../context/MobileContext';
import DetailPageHeader from '../shared/DetailPageHeader';
import { TabsList, TabsTrigger } from '../ui/tabs';
import './player-mobile-page.css';

// Use the current team role, never the account's legacy/global role.
export function usePlayerMobileView() {
  const { isPlayer } = useAuth();
  const { isParentView } = useParent();
  const { isMobile } = useMobileContext();
  return Boolean(isMobile && isPlayer && !isParentView);
}

// Presentation is shared by every mobile role. The hook above only selects
// player-specific data and must not be used to gate the shared design.
export function MobilePageHeader(props) {
  return <DetailPageHeader {...props} className={`tn-player-mobile-header ${props.className || ''}`} />;
}

export function MobilePageTabs({ items, label }) {
  return <TabsList className="tn-player-mobile-tabs" aria-label={label}>
    {items.map(({ value, label: title, icon: Icon, count }) => <TabsTrigger key={value} value={value}>
      {Icon && <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />}
      <span>{title}</span>
      {count > 0 && <span className="tn-player-mobile-tab-count">{count}</span>}
    </TabsTrigger>)}
  </TabsList>;
}

export default function MobilePage({ children, testId, className = '', ...header }) {
  return <div className={`tn-player-mobile-page ${className}`} data-testid={testId}>
    <MobilePageHeader {...header} />
    <div className="tn-player-mobile-content">{children}</div>
  </div>;
}

// Keep existing imports working while all roles adopt the same page chrome.
export { MobilePageHeader as PlayerMobileHeader, MobilePageTabs as PlayerMobileTabs };
